import { DEFNODE } from '../../../../../constants';
import DefNode from './DefNode';

export const nodeTypes = {
  [DEFNODE]: DefNode,
};
